<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal_form_ciudad_export"
      style="background-color: #00000082"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">
              Generar listado Ciudades
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Columnas"
                  data-toggle="tab"
                  href="#Columnas"
                  >Columnas</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="nombre" class="col-md-5">Nombre</label>
                    <input
                      type="text"
                      id="nombre"
                      v-model="filtros.nombre"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="cod_dane" class="col-md-5">codigo DANE</label>
                    <input
                      type="text"
                      id="cod_dane"
                      v-model="filtros.cod_dane"
                      class="col-md-7"
                    />
                  </div>
                  <div class="form-group row">
                    <label for="departamento_id" class="col-md-5"
                      >Departamento</label
                    >
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="departamento"
                      placeholder="Departamentos"
                      label="descripcion"
                      class="form-control form-control-sm p-0 col-md-7"
                      :options="listasForms.departamentos"
                      :filterable="true"
                      @input="getSelectDepartamentos()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="estado" class="col-md-5">Estado</label>
                    <select
                      id="estado"
                      class="form-control form-control-sm col-md-7"
                      v-model="filtros.estado"
                    >
                      <option value="">Seleccione...</option>
                      <option
                        v-for="estado in listasForms.estados"
                        :key="estado.numeracion"
                        :value="estado.numeracion"
                      >
                        {{ estado.descripcion }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade active show" id="Columnas">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-11">
                      <div class="form-group">
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="nombre1"
                              v-model="form.nombre"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="nombre1"
                              >Nombre</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="cod_dane1"
                              v-model="form.cod_dane"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="cod_dane1"
                              >Codigo DANE</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="departamento_id1"
                              v-model="form.departamento_id"
                              class="custom-control-input"
                            />
                            <label
                              class="custom-control-label"
                              for="departamento_id1"
                              >Departamento</label
                            >
                          </div>
                        </div>
                        <div>
                          <div class="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              id="estado1"
                              v-model="form.estado"
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for="estado1"
                              >Estado</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
                v-if="$store.getters.can('argentina.ciudades.export')"
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";
export default {
  name: "CiudadExport", //llegada tambien
  components: {
    vSelect,
    Loading,
  },
  data() {
    return {
      cargando: false,
      departamento: {},
      form: {
        nombre: true,
        cod_dane: true,
        departamento_id: true,
        estado: true,
      },
      filtros: {
        nombre: null,
        cod_dane: null,
        departamento_id: null,
        estado: null,
      },

      listasForms: {
        departamentos: [],
        estados: [],
      },
    };
  },

  methods: {
    getSelectDepartamentos() {
      this.filtros.departamento = {};
      this.filtros.departamento_id = null;
      if (this.departamento) {
        this.filtros.departamento = this.departamento;
        this.filtros.departamento_id = this.departamento.id;
      }
    },

    async getDepartamentos() {
      axios.get("/api/argentina/departamentos/lista").then((response) => {
        this.listasForms.departamentos = response.data;
      });
    },

    getEstado() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/argentina/ciudades/export",
        data: { form: this.form, filtros: this.filtros },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },

  async mounted() {
    this.cargando = true;
    await this.getDepartamentos();
    await this.getEstado();
    this.cargando = false;
  },
};
</script>
